import { useState } from "react";

import { Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import {
    DOWNLOAD_CSV_TITLE,
    DOWNLOAD_CSV_HELP,
    DOWNLOAD_CSV_PRO_ITEM_1,
    DOWNLOAD_CSV_PRO_ITEM_2,
    DOWNLOAD_CSV_PRO_ITEM_3,
    SAVE,
    NO_INSIGHTS,
} from "app/pages/sales-intelligence/modules/enrichment/utils/i18n/download.texts";
import { AssetsService } from "app/services/AssetsService";

import {
    StyledDownloadContainer,
    StyledDownloadHelpText,
    StyledDownloadImg,
    StyledDownloadTitle,
    StyledList,
    StyledListItem,
} from "./styles";

export const DownloadingCsv = ({ onSave, onCancel }: { onSave(): void; onCancel(): void }) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleSave = () => {
        setIsLoading(true);
        onSave();
    };

    return (
        <StyledDownloadContainer>
            <StyledDownloadImg src={AssetsService.assetUrl("/images/sales-intelligence/enriched-list.svg")} />
            <StyledDownloadTitle>{translate(DOWNLOAD_CSV_TITLE)}</StyledDownloadTitle>
            <StyledDownloadHelpText>{translate(DOWNLOAD_CSV_HELP)}</StyledDownloadHelpText>
            <StyledList>
                <StyledListItem>{translate(DOWNLOAD_CSV_PRO_ITEM_1)}</StyledListItem>
                <StyledListItem>{translate(DOWNLOAD_CSV_PRO_ITEM_2)}</StyledListItem>
                <StyledListItem>{translate(DOWNLOAD_CSV_PRO_ITEM_3)}</StyledListItem>
            </StyledList>
            <Button
                isLoading={isLoading}
                type="primary"
                onClick={handleSave}
            >
                {translate(SAVE)}
            </Button>
            <Button
                onClick={onCancel}
                className="cancel"
                type="flat"
            >
                {translate(NO_INSIGHTS)}
            </Button>
        </StyledDownloadContainer>
    );
};
